import Typography from "../../../components/Typography/Typography";
import Loader from "../../../components/Loader/Loader";
import AuthPageShell from "../../../components/AuthPageShell/AuthPageShell";
import shellStyles from "../../../components/AuthPageShell/AuthPageShell.module.scss";
import styles from "./LoginSuccess.module.scss";

const LoginSuccess = () => {
	return (
		<AuthPageShell scrollFooterReserve={false}>
			<div className={shellStyles.authTitleContainer}>
				<div className={shellStyles.authTitleTxt} style={{ margin: 0 }}>
					<Typography variant="h5">Redireccionando...</Typography>
				</div>
			</div>
			<div className={styles.loginSuccessBody}>
				<Loader></Loader>
			</div>
		</AuthPageShell>
	);
};

export default LoginSuccess;
